import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'

class OperatorsApiManager {
    static getUserOperators = () => {
        return ApiMethods.get(ENDPOINTS.USER_OPERATORS)
    }
    static getUserOperatorsV1 = () => {
        var userData = localStorage.getItem('userData')

        var userId = JSON.parse(userData)?.userId

        return ApiMethods.get(ENDPOINTS.OPERATORS_USER(userId))
    }

    static getOperatorUsers = () => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)

        return ApiMethods.get(ENDPOINTS.OPERATOR_USERS(group_id))
    }

    static getOperatorChannels = () => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)
        return ApiMethods.get(ENDPOINTS.OPERATOR_CHANNELS(group_id))
    }

    static getOperatorBanners = () => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)
        return ApiMethods.get(ENDPOINTS.OPERATOR_BANNERS(group_id))
    }

    static createUserInOperator = (user) => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)

        return ApiMethods.post(ENDPOINTS.CREATE_USER_IN_OPERATOR, {
            ...user,
            group_id: group_id,
        })
    }

    static deleteUserInOperator = (userId) => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)

        return ApiMethods.delete(
            ENDPOINTS.DELETE_USER_IN_OPERATOR(group_id, userId)
        )
    }

    static editUserInOperator = (userId, userEdit) => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)

        return ApiMethods.patch(ENDPOINTS.EDIT_USER_IN_OPERATOR(userId), {
            ...userEdit,
            group_id: group_id,
        })
    }
}

export default OperatorsApiManager
